











































































































import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { PartSearchPagination } from '@/components/part-search/PartSearchPagination';
import CatalogueSearchPartCard from './CatalogueSearchPartCard.vue';
import CatalogueSearchCard from './CatalogueSearchCard.vue';
import CatalogueSearchAssemblyCard from './CatalogueSearchAssemblyCard.vue';
import BaseMixin from '@/mixins/BaseMixin';
import { PartCatalogueSearchPage } from '@/entities/part-catalogue/PartCatalogueSearchPage';
import { PartCatalogueSearchModuleTypes } from '@/store/modules/part-catalogue-search';
import { Component, Prop, Mixins, Ref, Watch } from 'vue-property-decorator';
import URI from 'urijs';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';

@Component({
    components: {
        LoadingIndicator,
        CatalogueSearchPartCard,
        PartSearchPagination,
        CatalogueSearchCard,
        CatalogueSearchAssemblyCard,
    },
})
export default class CatalogueSearch extends Mixins(BaseMixin) {
    @Prop(String)
    private searchTerm!: string;
    @Prop(String)
    private brand!: string;
    @Prop(Number)
    private pageNumber!: number;

    private basePartCatalogueDetailsLink: string = '/PartCatalogue/Details/';
    private isLoading: boolean = true;

    protected mounted(): void {
        this.search();
    }

    private get baseSearchLinkWithoutPage(): string {
        return new URI('/CatalogueSearch')
            .addQuery({
                searchTerm: isNullOrWhitespace(this.searchTerm) ? undefined : this.searchTerm,
                brand: isNullOrWhitespace(this.brand) ? undefined : this.brand,
            })
            .toString();
    }

    private get catalogueSearchPage(): PartCatalogueSearchPage {
        const page = this.$store.getters[PartCatalogueSearchModuleTypes.getters.partCatalogueSearchResults];

        if (page) {
            return page;
        }

        return {
            totalNumberOfResults: 0,
            brandResult: { totalNumberOfResults: 0, entries: [] },
            modelGroupResult: { totalNumberOfResults: 0, entries: [] },
            modelResult: { totalNumberOfResults: 0, entries: [] },
            vinResult: { totalNumberOfResults: 0, entries: [] },
            diagramResult: { totalNumberOfResults: 0, diagrams: [] },
            partCatalogueParts: [],
        };
    }

    private get totalNumberOfResults(): number {
        return this.$store.getters[PartCatalogueSearchModuleTypes.getters.totalNumberOfParts];
    }

    private get numberOfPages(): number {
        return this.$store.getters[PartCatalogueSearchModuleTypes.getters.numberOfPages];
    }

    @Watch('catalogueSearchPage')
    private isLoadingWatch(): void {
        this.isLoading = this.catalogueSearchPage === null;
    }

    private search(): void {
        this.$store.dispatch(PartCatalogueSearchModuleTypes.actions.loadSearchResults, {
            searchTerm: this.searchTerm,
            brand: this.brand,
            pageNumber: this.pageNumber || 1,
        });
    }
}
